import React from "react";

import Translate from "Components/Translate";
import { InputTextarea } from "primereact/inputtextarea";

const TextareaInput = ({ register, inputName, errors, oldValue }) => {
  const { name, title, placeholder, required } = inputName;
  const isReq = required === undefined ? true : false;

  return (
    <div style={{ width: "300px" }}>
      <div className="flex flex-column ">
        <label>
          <Translate>{title}</Translate>
          {isReq && <span className="text-danger">*</span>}
        </label>
        <InputTextarea
          autoComplete="off"
          {...register(name)}
          invalid={errors[name]}
          size={10}
          placeholder={placeholder}
          defaultValue={oldValue}
        />
        {errors[name] && (
          <small className="text-danger">
            <Translate>{errors[name].message}</Translate>
          </small>
        )}
      </div>
    </div>
  );
};

export default TextareaInput;
